import {Card} from "../../Card";

export class VideoPokerHand {

    private cards: Array<Card> = [];
    private timesDoubled = 0;

    constructor() {

    }

    public getDoubledTimes(): number {
        return this.timesDoubled;
    }

    public addCard(card: Card): void {
        this.cards.push(card);
    }

    public getCards(): Array<Card> {
        return this.cards;
    }

    public setCards(cards: Array<Card>): void {
        this.cards = cards;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/serverResponseClasses/VideoPokerHand.ts